import {identity} from '@packages/utilities/fp/utils';

// Opaque type removed - see /packages/utilities/type-safety/README.md for more information
export type ComponentName = string;

export const name: (arg1: string) => ComponentName = identity;

export const nameToString: (arg1: ComponentName) => string = identity;
